<template><el-dialog :title="item?'编辑词条':'新增词条'" :visible="visible" @close="$emit('update:visible',false)"><el-form :model="form" label-width="100px"><el-form-item label="类型"><el-select v-model="form.term_type"><el-option label="品牌词" value="brand"/><el-option label="产品/SKU" value="sku"/><el-option label="风险词" value="abnormal"/></el-select></el-form-item><el-form-item label="词条"><el-input v-model="form.term"/></el-form-item><el-form-item label="分类"><el-input v-model="form.category"/></el-form-item><el-form-item label="风险等级"><el-select v-model="form.risk_level"><el-option v-for="x in ['低','中','高']" :key="x" :value="x"/></el-select></el-form-item><el-form-item label="启用"><el-switch v-model="form.active"/></el-form-item><el-form-item label="参与自动采集"><el-switch v-model="form.search_enabled"/></el-form-item><el-form-item v-if="form.term_type==='brand'&&form.search_enabled" label="检索平台"><el-checkbox-group v-model="form.platforms"><el-checkbox v-for="platform in readyPlatforms" :key="platform.platform" :label="platform.platform">{{platform.display_name}}</el-checkbox></el-checkbox-group><p v-if="!readyPlatforms.length" class="hint warning">当前没有通过实测的公开舆情平台，暂不能开启自动采集。</p><p v-else class="hint">仅显示已完成搜索、详情、评论和链接实测的平台。</p></el-form-item><el-form-item label="搜索优先级"><el-input-number v-model="form.search_priority" :min="0" :max="999"/><p class="hint">数值越大，自动搜索优先级越高。</p></el-form-item></el-form><span slot="footer"><el-button @click="$emit('update:visible',false)">取消</el-button><el-button type="primary" @click="save">保存</el-button></span></el-dialog></template>
<script>
import { yuqingApi } from '@/api/yuqing'

const empty = () => ({ term_type: 'brand', term: '', category: '', risk_level: '低', active: true, search_enabled: true, search_priority: 50, platforms: [] })

export default {
  props: ['visible', 'item'],
  data () { return { form: empty(), platforms: [] } },
  computed: {
    readyPlatforms () { return this.platforms.filter(platform => platform.search_ready) }
  },
  watch: {
    visible (visible) {
      if (!visible) return
      this.form = this.item ? { ...this.item, platforms: [...(this.item.platforms || [])] } : empty()
      this.loadPlatforms()
    }
  },
  methods: {
    async loadPlatforms () {
      try { this.platforms = (await yuqingApi.get('platform-readiness')).readiness || [] } catch (error) { this.$message.error(error.message) }
    },
    async save () {
      if (!this.form.term.trim()) return this.$message.warning('请输入词条')
      if (this.form.term_type !== 'brand') this.form.platforms = []
      if (this.form.term_type === 'brand' && this.form.search_enabled && !this.form.platforms.length) return this.$message.warning('请选择至少一个已就绪的检索平台')
      try {
        if (this.item) await yuqingApi.put(`lexicon/${this.item.id}`, this.form)
        else await yuqingApi.post('lexicon', this.form)
        this.$message.success('品牌词库已保存')
        this.$emit('update:visible', false)
        this.$emit('success')
      } catch (error) { this.$message.error(error.message) }
    }
  }
}
</script>
<style scoped>.hint{margin:6px 0 0;color:#909399;font-size:12px}.warning{color:#e6a23c}</style>
